import {
    GET_CHARACTER_MESSAGES_SUCCESS
} from '../actionTypes'
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';
import { colyClient } from '../../services/Panel-initialisation.service';
import LZString from 'lz-string'

export const getCharacterMessagesSuccess = payload => ({
    type: GET_CHARACTER_MESSAGES_SUCCESS,
    payload
})

export const getCharacterMessagesAsync = payload => dispatch => {
    const { characterId } = payload

    return client.service('character-messages').find({
          query: {
            characterId,
            $limit: 100,
            $sort: {
              createdAt: -1
            },
            $skip: payload?.skip || 0
          }
        })
        .then((response) => {
            dispatch(getCharacterMessagesSuccess(response
                .map(characterMessage => ({
                    ...characterMessage,
                    targetFurnitureName: characterMessage.targetFurnitureName && JSON.parse(LZString.decompressFromUTF16(characterMessage.targetFurnitureName))
                }))
                .sort((a, b) => {
                    if (!a.lastUpdatedAt) {
                        return 1;
                    }

                    if (!b.lastUpdatedAt) {
                        return -1;
                    }
                    return b.lastUpdatedAt - a.lastUpdatedAt
                }))
            )
            return response
        })
        .catch((error) => {
            console.error('error: ', error);
            // dispatch(showUnknownError())
        });
}
